import React, {Component} from 'react';
import { Switch, Route, Link, Redirect, BrowserRouter as Router } from 'react-router-dom'
import Dashboard from './Dashboard.js';
import NewAppointment from './NewAppointment.js';
import NewSubscription from './NewSubscription.js';
import SubscriptionDashboard from './SubscriptionDashboard.js';
import ShowDetails from './ShowDetails.js';
import RedeemGiftcard from './RedeemGiftcard.js';
import MyGarage from './MyGarage.js';
import Locations from './Locations.js';
import NewGiftcard from './NewGiftcard.js';
import GiftcardMenu from './GiftcardMenu.js';
import ContactUs from './ContactUs.js';
import UserProfile from './UserProfile.js';
import CreditCards from './CreditCards.js';
import Footer from './Footer.js';
import PrivateRoute from './PrivateRoute.js';

export default class Main extends Component {
  render() {
    return (
      <div id="main">
        <Switch>
          <PrivateRoute path='/new-appointment' component={NewAppointment}/>
          <PrivateRoute path='/credit-cards' component={CreditCards}/>
          {/*<PrivateRoute path='/subscriptions' component={SubscriptionDashboard}/>*/}
          <PrivateRoute path='/profile' component={UserProfile}/>
          {/*<PrivateRoute path='/new-subscription' component={NewSubscription}/>*/}
          <PrivateRoute path='/giftcards/:image_id' component={NewGiftcard}/>
          <PrivateRoute path='/giftcards' component={GiftcardMenu}/>
          <PrivateRoute path='/details/:id' component={ShowDetails}/>
          <PrivateRoute path='/redeem' component={RedeemGiftcard}/>
          <PrivateRoute exact path='/dashboard' component={Dashboard} appointments={this.props.appointments}/>
          <PrivateRoute exact path='/vehicles' component={MyGarage}/>
          <PrivateRoute exact path='/locations' component={Locations}/>
          <PrivateRoute exact path='/contact' component={ContactUs}/>
          <PrivateRoute exact path='/' component={Dashboard} appointments={this.props.appointments}/>
        </Switch>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/Main.js